module.exports = __webpack_public_path__ + "static/media/filterIcon.b5be918c.svg";